import { allSettingsKeys } from 'defs/profile';
import { ActionType as ProfileActionType, actionTypes as profileAT } from 'store/profile';
import { SettingsActionType } from './settings.actionCreators';
import { REQUEST_UPDATE_SETTINGS, REQUEST_UPDATE_SETTINGS_SUCCESS } from './settings.actionTypes';

export type SettingsType = { [key: string]: string };

export type SettingsStateType = {
	[setting: string]: boolean;
};

export type RootStateType = {
	profile: SettingsStateType;
};

export const initialState: SettingsStateType = ((): SettingsStateType => {
	const initialSettings = {};

	allSettingsKeys.forEach((settingKey: string) => {
		initialSettings[settingKey] = false;
	});

	return {
		...initialSettings,
	};
})();

export default (state: SettingsStateType = initialState, action: SettingsActionType | ProfileActionType) => {
	switch (action.type) {
		case profileAT.REQUEST_USER_DATA_SUCCESS:
			const profileDataKeys = Object.keys(action.data);
			const newState = state;
			let shouldReturnNewState = false;

			allSettingsKeys.forEach((settingKey: string) => {
				if (!!~profileDataKeys.indexOf(settingKey)) {
					shouldReturnNewState = true;
					newState[settingKey] = !!action.data[settingKey];
				}
			});

			return shouldReturnNewState ? newState : state;
		case REQUEST_UPDATE_SETTINGS:
			return {
				...state,
			};
		case REQUEST_UPDATE_SETTINGS_SUCCESS:
			const updatedSettings = action.settings || {};
			const updatedKey = action.key || null;

			if (updatedKey) {
				return {
					...state,
					[updatedKey]: updatedSettings[updatedKey],
				};
			}

			return state;
		default:
			return state;
	}
};
